import { Form } from 'react-bootstrap';

import { updateDraftMode } from '@redux/note-details/methods';
import { useApplicationState } from '@hooks/common/use-application-state';

function DraftToggleButton({ isSavingDraftContent }: { isSavingDraftContent: boolean; }) {
  const { draftMode }= useApplicationState((state) => ({
    draftMode: state.noteDetails.draftMode,
  }))

  return (
  <Form>
    <Form.Check
      disabled={isSavingDraftContent}
      type='switch'
      label='Create Draft'
      className='cursor-pointer'
      checked={draftMode}
      onChange={(e) => updateDraftMode(e.target.checked)}
    />
  </Form>
  )
}

export default DraftToggleButton;
